type StorageLike = {
  setItem: (key: string, value: string) => void;
  getItem: (key: string) => string | null;
  removeItem: (key: string) => void;
};

// fallback за native – in-memory storage (няма да се пази след рестарт на app-а)
const memoryStore: Record<string, string> = {};

const memoryStorage: StorageLike = {
  setItem: (key, value) => {
    memoryStore[key] = value;
  },
  getItem: (key) => (key in memoryStore ? memoryStore[key] : null),
  removeItem: (key) => {
    delete memoryStore[key];
  },
};

const browserStorage: StorageLike | null =
  typeof localStorage !== "undefined"
    ? {
        setItem: (key, value) => localStorage.setItem(key, value),
        getItem: (key) => localStorage.getItem(key),
        removeItem: (key) => localStorage.removeItem(key),
      }
    : null;

// избираме реален localStorage (web) или in-memory (native)
const storage: StorageLike = browserStorage ?? memoryStorage;

const LS = {
  set: (key: string, value: string) => storage.setItem(key, value),
  get: (key: string) => storage.getItem(key),
  remove: (key: string) => storage.removeItem(key),
  getCasinoId: () => storage.getItem("casinoId"),
};

export default LS;
